
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import DealerFloat from "./components/feature/DealerFloat";
import { Suspense } from "react";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <div className="min-h-screen bg-white dark:bg-[#0A1929] transition-colors duration-500">
          <Suspense fallback={
            <div className="min-h-screen flex items-center justify-center bg-white">
              <div className="flex flex-col items-center gap-4">
                <div className="w-12 h-12 border-4 border-teal-500 border-t-transparent rounded-full animate-spin"></div>
                <p className="text-gray-500 text-sm font-medium">Yükleniyor...</p>
              </div>
            </div>
          }>
            <AppRoutes />
          </Suspense>
          <DealerFloat />
        </div>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
